import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';

export const StyledToastContainer = styled(ToastContainer).attrs({
    className: 'toast-container',
    toastClassName: 'toast',
    bodyClassName: 'body',
    progressClassName: 'progress',
  })`
    /* .toast-container */
    width: 100%;
  
     /* .toast is passed to toastClassName */
    .toast {
      min-height:45px;
    }
  
    button[aria-label="close"] {
      display: none;
    }
  
    /* .body is passed to bodyClassName */
    .body {  
    }
  
    /* .progress is passed to progressClassName */
    .progress {}

    .Toastify__toast--error {
      background-color: #F2D6D0;
      margin-top: 10px;
    }
    .Toastify__toast--warning {
      background-color: #FFF7D4;
    }
    .Toastify__toast--success {
      background-color:#D0F2E4;
      margin-top: 60px;
    }
  `;